import { render } from "./addressDetails.vue?vue&type=template&id=2612f0da"
import script from "./addressDetails.vue?vue&type=script&lang=js"
export * from "./addressDetails.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../procollege/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__